import type { ICartItemDetail } from '@/common/interfaces/cart.interface';

export const getStoreCartItemKeys = (items: ICartItemDetail[]): string =>
  items
    .map((item) => `${item.id}`)
    .sort()
    .join(',');

export const matchesStoreCartItemId = (item: ICartItemDetail, removedId: string): boolean => {
  const normalizedRemovedId = String(removedId);

  return [item.id, item.cartItemId]
    .filter((value): value is number => value !== undefined && value !== null)
    .some((value) => String(value) === normalizedRemovedId);
};

export const filterRemovedStoreCartItems = (
  items: ICartItemDetail[],
  removedId: string
): ICartItemDetail[] => items.filter((item) => !matchesStoreCartItemId(item, removedId));

/** Cart-item ids from a store-cart API response (`id` is the persisted cart line id). */
export const resolveStoreCartApiItemIds = (items: ICartItemDetail[]): number[] => {
  const ids = new Set<number>();

  items.forEach((item) => {
    const cartItemId = Number(item.id);

    if (Number.isFinite(cartItemId) && cartItemId > 0) {
      ids.add(cartItemId);
    }
  });

  return [...ids];
};

/** Best-effort cart-item ids from hydrated checkout/cart form rows. */
export const resolveStoreCartItemIdsFromState = (items: ICartItemDetail[]): number[] => {
  const ids = new Set<number>();

  items.forEach((item) => {
    const cartItemId = Number(item.cartItemId ?? item.id);

    if (Number.isFinite(cartItemId) && cartItemId > 0) {
      ids.add(cartItemId);
    }
  });

  return [...ids];
};
